var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-1 button button-primary",on:{"click":_vm.requestInvite}},[(_vm.submittingInvite)?[_c('i',{staticClass:"fa fa-spin fa-spinner"})]:[_vm._v(_vm._s(_vm.$t('.button.invite')))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }